<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-06",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 47,
      nextPage: '/questionnaire/section3/7',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'How often do you eat coarse grains?',
        btn: [
          [
            {
              text: 'Rarely',
              operation: 'flag3-1_Vegan_add suggestion 3 & flag3-1_Anything_add suggestion 9'
            }
          ],[
            {
              text: 'Occasionally',
              operation: 'flag3-1_Vegan_add suggestion 3 & flag3-1_Anything_add suggestion 9'
            }
          ],[
            {
              text: 'Regularly',
              operation: 'flag3-1_Vegan_add suggestion 3 & flag3-1_Anything_add suggestion 9'
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
